import React from 'react';
import { Button, ButtonProps } from 'antd';
import styles from './index.module.css';

export const IconButton = (props: ButtonProps & React.RefAttributes<HTMLElement>) => {
  return <Button {...props} className={styles.button} />;
};
